import { createTheme } from '@mui/material/styles';
const theme = createTheme({
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: '#120f1c',
                    maxWidth: 200,
                },
                arrow: {
                    color: '#120f1c',
                },
                tooltipPlacementTop: {
                    marginBottom: '10px !important',
                },
                tooltipPlacementBottom: {
                    marginTop: '10px !important',
                },
                tooltipPlacementRight: {
                    marginLeft: '10px !important',
                },
                popper: {
                    zIndex: 9999999,
                },
            },
        },
    },
});
export default theme;
